import {ProductSubscriptionSourceReference} from './ProductSubscriptionSourceReference';

/**
 * @export
 * @type UpdateProductAccessTermRequest
 */
export type UpdateProductAccessTermRequest = {
    status: UpdateProductAccessTermRequestStatus;
    startDate: string;
    endDate: string;
    seats?: number;
    sourceRefs?: Array<ProductSubscriptionSourceReference>;
}

export enum UpdateProductAccessTermRequestStatus {
    ACTIVE = 'ACTIVE',
    CANCEL = 'CANCEL'
}